import {
  ACTIVATE_TMS_FAILED,
  ACTIVATE_TMS_LOADING,
  ACTIVATE_TMS_SUCCESS,
  GET_ALLTMS_REMOVE,

} from "../types";

const initialState = {
  loading: false,
  error: null,
  TMS: null,
  status: null,
};

export const activateTMSReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case ACTIVATE_TMS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ACTIVATE_TMS_SUCCESS:
      return {
        ...state,
        loading: false,
        TMS: action.payload,
        status: action.status,
        error: null,
      };
    case ACTIVATE_TMS_FAILED:
      return {
        ...state,
        loading: false,
        TMS: null,
        status: null,
        error: action.error,
      };
    case GET_ALLTMS_REMOVE:
      return initialState;
    default:
      return state;
  }
};
